// SwipedSlider.tsx
// import React from "react";
// import { Swiper, SwiperSlide } from "swiper/react";
// import "swiper/css";
// import "swiper/css/pagination";
import { Pagination, Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";

// import { Pagination, Autoplay } from "swiper/modules";
import { CatagoryList } from "../CatagoryList";
// import { CategoryList } from "./CategoryList";
// Assuming your category list is imported

const SwipedSlider = () => {
  const mainCategories = Object.keys(CatagoryList);

  return (
    <div className="w-full max-w-5xl mx-auto px-4 my-28 mb-10">
      {/* Section Title */}
      <h1 className="font-bold text-5xl text-black text-center mb-10 mt-10">
        Most Popular Categories
      </h1>

      {/* Swiper Slider */}
      <Swiper
        modules={[Pagination, Autoplay]}
        spaceBetween={30}
        slidesPerView={1}
        slidesPerGroup={1}
        loop
        pagination={{ clickable: true }}
        autoplay={{ delay: 3000 }}
        breakpoints={{
          640: { slidesPerView: 3, spaceBetween: 20 },
          1024: { slidesPerView: 5, spaceBetween: 10 },
        }}
        className="my-10"
      >
        {mainCategories.map((category, index) => {
          const categoryItems = CatagoryList[category]; // Get the list of items in each category
          return (
            <SwiperSlide key={index} className="py-16">
              <div className="group bg-[#F9FDFF] p-10 space-y-5 shadow-lg rounded-lg overflow-hidden transform transition-transform duration-300 hover:scale-105 flex flex-col items-center h-56">
                <div className="flex flex-col space-y-4 items-center justify-center space-x-3 flex-grow">
                  {/* Icon and Title */}
                  <span className="text-6xl text-primary">
                    {categoryItems[0]?.icon}
                  </span>{" "}
                  {/* Using text-primary for color */}
                  <h2 className="font-semibold text-lg text-center mb-4">
                    {category}
                  </h2>
                </div>
                {/* Total Item Count */}
                <span className="text-sm text-gray-500">
                  {categoryItems.length}{" "}
                  {categoryItems.length > 1 ? "items" : "item"}
                </span>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};

export default SwipedSlider;
